import PageCache from '../page-cache';
import formatMarkdown from '../format-markdown';

PageCache.await('allseries.raw').then(function (data) {
  var allSeries = data.seriesDepthOne.series;
  var seriesMap = [];

  allSeries.forEach(function (item) {
    var found = seriesMap[item.series_code];

    // if existing series has a larger year, use that
    if (found && found.year > item.year) {
      found.year = found.year;
    } else {
      seriesMap[item.series_code] = {
        series_name: item.series_name,
        series_display_name: formatMarkdown(item.series_display_name),
        year: item.year
      };
    }
  });

  PageCache.set('allseries.map', seriesMap);
  return seriesMap;
});
